export default function PerformanceMonitor() {
  return null
}
